import "react";
import "./auth-service-tools177.js";
import { createOptionalContext } from "./auth-service-tools178.js";
const [InputWrapperProvider, useInputWrapperContext] = createOptionalContext({
  offsetBottom: false,
  offsetTop: false,
  describedBy: void 0,
  getStyles: null,
  inputId: void 0,
  labelId: void 0
});
export { InputWrapperProvider, useInputWrapperContext };